import React, { useState, useEffect, useRef } from 'react';

const LazyImage = ({ src, alt, placeholder,style, ...props }: { src: string, alt: string, placeholder?: string, style?: React.CSSProperties, props?: any }) => {
  const [isVisible, setIsVisible] = useState(false);
  const imageRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing after loading
        }
      },
      {
        rootMargin: '100px', // Load images slightly before they are in view
      }
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => {
      if (observer && imageRef.current) {
        observer.disconnect();
      }
    };
  }, []);

  return (
    <img
      ref={imageRef}
      src={isVisible ? src : placeholder} // Show placeholder until image is in view
      alt={alt}
      style={style} 
      {...props}
    />
  );
};

export default LazyImage;
